var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhy5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16429",
    "data-name": "Group 16429",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2088",
    "data-name": "Rectangle 2088",
    width: 39,
    height: 39,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16338",
    "data-name": "Group 16338",
    transform: "translate(3.292 5.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16337",
    "data-name": "Group 16337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "user-list",
    d: "M32.255,20.548a1.649,1.649,0,0,0-1.219-.539H1.649a1.65,1.65,0,0,0-1.642,1.8L1.575,38.667a1.65,1.65,0,0,0,1.642,1.5h26.25a1.65,1.65,0,0,0,1.642-1.5l1.568-16.854A1.651,1.651,0,0,0,32.255,20.548Zm-10.41,16.16h-11a1.65,1.65,0,0,1-1.65-1.651,4.069,4.069,0,0,1,4.063-4.065h1.184a3.946,3.946,0,1,1,3.8,0h1.184a4.069,4.069,0,0,1,4.06,3.929c0,.045.006.09.006.136A1.65,1.65,0,0,1,21.844,36.708Zm7.667-19.772a1.238,1.238,0,0,1-1.237,1.238H4.411a1.238,1.238,0,0,1,0-2.476H28.274A1.238,1.238,0,0,1,29.511,16.936Zm-3.266-4.567a1.238,1.238,0,0,1-1.237,1.238H7.677a1.238,1.238,0,0,1,0-2.476H25.008A1.238,1.238,0,0,1,26.245,12.369Z",
    transform: "translate(0 -11.131)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    width: 20.903,
    height: 15.643,
    transform: "translate(5.919 11.552)",
    fill: "#f9b316"
  })), /*#__PURE__*/React.createElement("g", {
    id: "university",
    transform: "translate(9.994 12.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8248",
    "data-name": "Path 8248",
    d: "M12.291,195.494h-.933V188.6a.371.371,0,0,0-.371-.371H9.869v7.264H9.127v-2.052H8.379v2.052H7.636v-2.052H5.026v2.052H4.284v-2.052H3.536v2.052H2.794v-7.26H1.675a.371.371,0,0,0-.371.371v6.889H.371a.371.371,0,1,0,0,.742h11.92a.371.371,0,1,0,0-.742Z",
    transform: "translate(0 -183.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8249",
    "data-name": "Path 8249",
    d: "M148.16,3.19H146.1c.006-.136,0-.084,0-1.515h1.839a.4.4,0,0,0,.4-.4V.371A.371.371,0,0,0,147.97,0h-2.235a.371.371,0,0,0-.371.371V3.19h-2.053a.371.371,0,0,0-.371.371V9.127h5.591V3.561A.371.371,0,0,0,148.16,3.19ZM144.8,8.007h-.745a.371.371,0,0,1,0-.742h.745a.371.371,0,1,1,0,.742Zm0-1.49h-.745a.371.371,0,0,1,0-.742h.745a.371.371,0,1,1,0,.742Zm0-1.49h-.745a.371.371,0,0,1,0-.742h.745a.371.371,0,1,1,0,.742Zm2.608,2.98h-.745a.371.371,0,1,1,0-.742h.745a.371.371,0,1,1,0,.742Zm0-1.49h-.745a.371.371,0,1,1,0-.742h.745a.371.371,0,1,1,0,.742Zm0-1.49h-.745a.371.371,0,1,1,0-.742h.745a.371.371,0,1,1,0,.742Z",
    transform: "translate(-139.404 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy5);
export default __webpack_public_path__ + "static/media/why5.bfe84fcaac5b026e4ced381f38e4c394.svg";
export { ForwardRef as ReactComponent };